import React, { useEffect } from 'react';
import { Row, Card } from 'react-bootstrap';
import OTIF from './OTIF/OTIF';
import ScanningOff from './stillage-scanning/ScanningOff';
import Remakes from './remakes/Remakes';
import Backlog from './discrepancies/Backlog';
import Shelled from './shelled/Shelled';
import BIT from './bit/BIT';
import CoQ from './coq/CoQ';
import Filters from './Filters';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAllTiles } from 'slices/glassDashboard/fetchAllTiles';
import GlassDataModal from './modal/GlassDataModal';
import TripleLamTough from './tripleLamTough/TripleLamTough';
import DisputeSummary from './dispute-summary/DisputeSummary';
import OtherIssues from './other-issues/OtherIssues';

const GlassDashboard = () => {
    const dispatch = useDispatch();
    const { start, end, requestId } = useSelector(s => s.glassSearchFilter);

    useEffect(() => {
        const promise = dispatch(fetchAllTiles({ start, end }));

        return () => {
            promise.abort();
        };
    }, [requestId]);

    return (
        <>
            <Row className='g-3 mb-3'>
                <Card className='border-0 shadow-sm border-1' style={{ minHeight: '150px' }}>
                    <Filters />
                </Card>
            </Row>
            <Row className='g-3 mb-3'>
                <OTIF />
            </Row>
            <Row className='g-3 mb-3'>
                <CoQ />
            </Row>
            <Row className='g-3 mb-3'>
                <ScanningOff />
                <Remakes />
            </Row>
            <Row className='g-3 mb-3'>
                <OtherIssues />
                <BIT />
                <Shelled />
            </Row>
            <Row className='g-3 mb-3'>
                <Backlog />
                <TripleLamTough />
                <DisputeSummary />
            </Row>
            <GlassDataModal />
        </>
    );
}

export default GlassDashboard;